import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 维护图标暴露的css变量基类 */
export abstract class _MaskMaintainBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 遮罩层圆角弧度 */
  ['--mask-maintain-border-radius']?: string;
  /** 维护圆形图标的宽度 */
  ['--maintain-circle-width']?: string;
  /** 维护圆形图标的高度 */
  ['--maintain-circle-height']?: string;
  /** 维护文案与圆形图标的间距 */
  ['--maintain-text-margin-top']?: string;
  /** 维护文案的字号大小 */
  ['--maintain-text-font-size']?: string
}
